import { Routes } from '@angular/router';
import { Home } from './components/home/home';
import { Offerings } from './components/offerings/offerings';
import { Work } from './components/work/work';
import { PekingDuckMealKit } from './components/peking-duck-meal-kit/peking-duck-meal-kit';



import { HttpClientModule } from '@angular/common/http';

export const routes: Routes = [
	{ path: '', component: Home },
	{ path: 'menu', component: Offerings },
	{ path: 'contact', component: Work },
	{ path: 'peking-duck-meal-kit', component: PekingDuckMealKit }


];
